import api from '@/api'

function get (success, error) {
  return api.profile.get((profile) => {
    api.get(profile.company.collection('stores'), success, error)
  }, error)
}

function sync (company, callbacks, error) {
  return api.subscribe(company.collection('stores').where('deleted', '==', false), callbacks, null, error)
}

function list (success, error) {
  return api.profile.get((profile) => {
    api.get(profile.company.collection('stores'), success, error)
  }, error)
}

function add (store, success, error) {
  store.deleted = false
  return api.profile.get((profile) => {
    api.add(profile.company.collection('stores'), store, success, error)
  })
}

export default {
  get,
  sync,
  list,
  add
}



// WEBPACK FOOTER //
// ./src/api/stores.js